import Bind from 'bind.js';

export default class BuyNow {
  constructor({parentElement, data}) {
    this.parentElement = parentElement;
    this.data = data;
    this.addContent();
  }

  addContent() {
    let template = `
    <div class="sidebyside_text">
      <div class="title span12"></div>
      <div class="para column1 span6"></div>
      <div class="para column2 span6"></div>
    </div>
    `

    this.parentElement.insertAdjacentHTML("afterbegin", template);

    this.editor = Bind(
      {
        title: this.data.get('title'),
        column1: this.data.get('column1'),
        column2: this.data.get('column2')
      },
      {
        title: '.sidebyside_text .title',
        column1: '.sidebyside_text .column1',
        column2: '.sidebyside_text .column2'
      }
    );
  }

  reRender(data) {
    this.data = data;
    this.editor.title = data.get('title');
    this.editor.column1 = data.get('column1');
    this.editor.column2 = data.get('column2');
  }
}



// WEBPACK FOOTER //
// ./src/renderers/SideBySideText.js